/**
 * Giveaway tickets block — progressive enhancement.
 *
 * Desktop details use the Popover API; mobile details use the theme's native
 * drawer-element (opened via the trigger's aria-controls — no JS here). This
 * only adds what CSS/those APIs can't:
 *   - play the fan once when scrolled into view, then settle back to a stack
 *   - fan out on tap (touch devices), then stack back
 *   - open the desktop popover on hover (pointer devices only)
 *   - keep the ticket count in sync with the selected variant
 *
 * Ticket count is always pounds-based. Under Shopify Markets, variant.price
 * (from Liquid and the variantChange payload) is in the customer's presentment
 * currency, so tickets = floor(price / rate / 100), where rate is the exact
 * window.Shopify.currency.rate (presentment per 1 GBP; 1 for GBP customers).
 * Shopify rounds the displayed presentment price, so a foreign-currency count
 * can differ from the GBP count by one ticket.
 */
(function () {
  function init(root) {
    if (root.dataset.gwReady) return;
    root.dataset.gwReady = "true";

    var stack = root.querySelector(".giveaway__stack");
    var counts = root.querySelectorAll("[data-gw-count]");
    var popover = root.querySelector(".giveaway__popover");
    var trigger = root.querySelector(".giveaway__more[popovertarget]");
    var canHover =
      window.matchMedia && window.matchMedia("(hover: hover)").matches;
    var fanTimer;

    function fan(duration) {
      if (!stack) return;
      root.classList.add("is-fanned");
      clearTimeout(fanTimer);
      fanTimer = setTimeout(function () {
        root.classList.remove("is-fanned");
      }, duration);
    }

    // Play the fan once when the block scrolls into view.
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            fan(1300);
            io.disconnect();
          });
        },
        { threshold: 0.4 },
      );
      io.observe(root);
    }

    // Touch: tap the stack to fan out, then settle back.
    if (!canHover && stack) {
      stack.addEventListener("click", function () {
        fan(1500);
      });
    }

    // Pointer devices: open the desktop popover on hover. Touch devices use the
    // mobile trigger, which opens the native drawer-element via aria-controls.
    if (
      popover &&
      trigger &&
      canHover &&
      typeof popover.showPopover === "function"
    ) {
      var overPopover = false;
      var show = function () {
        try {
          popover.showPopover();
        } catch (e) {}
      };
      var hide = function () {
        try {
          popover.hidePopover();
        } catch (e) {}
      };
      trigger.addEventListener("mouseenter", show);
      trigger.addEventListener("mouseleave", function () {
        setTimeout(function () {
          if (!overPopover) hide();
        }, 90);
      });
      popover.addEventListener("mouseenter", function () {
        overPopover = true;
      });
      popover.addEventListener("mouseleave", function () {
        overPopover = false;
        hide();
      });
    }

    // variant.price is in the customer's presentment currency; divide by the
    // exact (un-rounded) currency rate to recover GBP, then one ticket per £1.
    var rate = Number(window.Shopify.currency.rate);
    function setCount(presentmentPrice) {
      var tickets = Math.max(0, Math.floor(presentmentPrice / rate / 100));
      counts.forEach(function (el) {
        el.textContent = tickets;
      });
    }

    // Re-derive the server-rendered count in the customer's currency on load
    // (exact for GBP, corrected for other markets before the block is scrolled to).
    setCount(Number(root.dataset.gwPrice));

    function update(variant) {
      if (!variant || typeof variant.price !== "number") return;
      setCount(variant.price);
    }

    if (
      window.theme &&
      theme.pubsub &&
      theme.pubsub.subscribe &&
      theme.pubsub.PUB_SUB_EVENTS
    ) {
      theme.pubsub.subscribe(
        theme.pubsub.PUB_SUB_EVENTS.variantChange,
        function (payload) {
          update(payload && payload.data && payload.data.variant);
        },
      );
    } else {
      (root.closest("product-info") || document).addEventListener(
        "variant:change",
        function (event) {
          update(event.detail && event.detail.variant);
        },
      );
    }
  }

  function initAll() {
    document.querySelectorAll("[data-giveaway]").forEach(init);
  }

  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("page:loaded", initAll);
})();
